import type { PropsWithChildren, FunctionComponent } from 'react'
import { Fragment } from 'react'
import { matchPath, useLocation } from 'react-router'
import { useCurrentAccountDetails } from '../../../../api/current-account/currentAccount.hooks'
import { useGetRetailersForPartnerQuery } from '../../../../__codegen__/api'
import { URL_PARTNER_SCOPED } from '../../../../utils/routing/routes'

// Load all globally-required data before the app boots
export const AppProviderPreloader: FunctionComponent<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { loading } = useCurrentAccountDetails()
  const { pathname } = useLocation()

  // Manually check URL for partner_id since we are above the actual Router Routes
  const partnerMatch = matchPath<{ partner_id: string }>(pathname, {
    path: URL_PARTNER_SCOPED,
  })
  const partnerIdFromUrl = partnerMatch?.params.partner_id

  /**
   * Performance optimization:
   * This triggers the Partner Data fetch in parallel with the main Auth check.
   * It is placed high in the tree so it can overlap network requests.
   * Apollo will combine the queries into a single request if components lower in the tree
   * are fetching the same data before this completes. Otherwise this query will be cached, and subsequent
   * requests will receive cached data.
   */
  useGetRetailersForPartnerQuery({
    variables: { partnerId: partnerIdFromUrl },
    skip: !partnerIdFromUrl,
  })

  if (loading) {
    return null
  }

  return <Fragment>{children}</Fragment>
}
